export default __webpack_public_path__ + "static/media/headset-icon.b93d7e6c.svg";